module.exports = __webpack_public_path__ + "img/add (3).adb89944.svg";